export const SUPABASE_URL = "https://pobobufclzbxpawqtxwx.supabase.co";
export const SUPABASE_ANON_KEY =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBvYm9idWZjbHpieHBhd3F0eHd4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMwNjMyMDAsImV4cCI6MjA4ODYzOTIwMH0.nc97mZ-_WW3vZhIwMWtC5ILb3KGcq_dV6rxPZH2M1u0";

// Emails that must NEVER have app access (service/OAuth-only accounts).
// Everything else is gated by the crew_members table in PermissionsProvider —
// any email can sign in, but only invited crew members reach the app.
//
// This is a denylist, not an admin allowlist. Owner/admin emails live in
// src/config/adminEmails.js (client) and api/_adminEmails.js (server).
const BLOCKED_EMAILS = new Set(["ap@browning-electric.ca"]);

export function isEmailAllowed(email) {
  if (!email) return false;
  const lower = email.toLowerCase();
  if (BLOCKED_EMAILS.has(lower)) return false;
  return true;
}
